// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"e2ea986a","441":"8fd39129"}[chunkId] + ".chunk.js";
};